<template>
    <svg 
        :class="{
            'icon__threads': hoverState == true
        }"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 167 195">
        <defs>
            <clipPath id="clip-Web_1920_1">
            <rect width="167" height="195"/>
            </clipPath>
        </defs>
        <g id="Web_1920_1" data-name="Web 1920 – 1" clip-path="url(#clip-Web_1920_1)">
            <path id="threads-seeklogo.com-2" d="M141.537,88.988q-1.24-.595-2.518-1.143c-1.482-27.307-16.4-42.94-41.457-43.1h-.34c-14.986,0-27.449,6.4-35.12,18.036l13.779,9.452c5.731-8.695,14.724-10.548,21.348-10.548h.229c8.249.053,14.474,2.451,18.5,7.129,2.932,3.405,4.893,8.111,5.864,14.05a105.419,105.419,0,0,0-23.68-1.141C74.325,83.1,59.011,96.988,60.04,116.292a29.773,29.773,0,0,0,13.735,23.719c7.047,4.652,16.124,6.927,25.557,6.412,12.458-.683,22.231-5.436,29.049-14.127,5.178-6.6,8.453-15.153,9.9-25.93,5.937,3.583,10.337,8.3,12.767,13.966,4.132,9.635,4.373,25.468-8.546,38.376-11.319,11.308-24.925,16.2-45.488,16.351-22.809-.169-40.06-7.484-51.275-21.742C35.236,139.966,29.808,120.682,29.605,96c.2-24.682,5.63-43.966,16.133-57.317C56.954,24.425,74.2,17.11,97.013,16.941c22.975.171,40.526,7.521,52.171,21.847,5.71,7.026,10.015,15.861,12.853,26.162l16.147-4.308c-3.44-12.68-8.853-23.606-16.219-32.668C147.036,9.607,125.2.2,97.07,0h-.113C68.882.194,47.292,9.642,32.788,28.079,19.882,44.486,13.224,67.316,13,95.933v.135c.224,28.617,6.881,51.447,19.788,67.854,14.5,18.437,36.093,27.885,64.169,28.079h.113c24.96-.173,42.554-6.708,57.048-21.189,18.963-18.945,18.392-42.692,12.142-57.27C161.776,103.087,153.227,94.6,141.537,88.988Zm-43.1,40.519c-10.44.588-21.286-4.1-21.821-14.135-.4-7.442,5.3-15.746,22.462-16.735q2.949-.17,5.79-.169a81.592,81.592,0,0,1,17.371,1.765C120.264,124.935,108.662,128.946,98.44,129.507Z" transform="translate(-12 1)" fill="#fff"/>
        </g>
    </svg>

</template>

<script>
export default {
    name: 'IconThreads',
    props: {
        hoverState: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/all.scss';

.icon__threads {
	path {
		transition: all 0.3s ease;
	}
    &:hover {
        path {
            fill: $primary;
        }
    }
}
</style>
